module.exports = __webpack_public_path__ + "img/img-qcode.32c7d5bf.png";